import type { PapelEscritorio } from '@/types/escritorio/escritorioTypes';

const PAPEIS_ADMIN_DO_ESCRITORIO: PapelEscritorio[] = ['MASTER_ADMIN', 'ADMIN'];

/**
 * Quem administra o workspace — `MASTER_ADMIN` ou `ADMIN`. Espelha o `requireWorkspaceAdmin`
 * do backend: telas que checarem só o master mostram porta fechada para metade dos admins.
 */
export function ehAdminDoEscritorio(papel: PapelEscritorio | null | undefined): boolean {
  return papel != null && PAPEIS_ADMIN_DO_ESCRITORIO.includes(papel);
}
